import { TeContainer, TeGrid } from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

import { Section } from '../../utils/styling';
import Header from '../../components/Header';
import Card from '../../components/Card';
import { useOauthClients } from '../Apps/apps.queries';

function Licenses() {
  const { t } = useTranslation('products');
  const { data: oauthClientsData } = useOauthClients();

  // We're getting the Product Registration App URL from the oauthClientsData by glyphIcon, until we have a better solution.
  const licensesAppUrl = useMemo(() => {
    const licensesClient = oauthClientsData?.items.find(
      (client) => client.category === 'topcon.apps.licenses' && client.glyphIcon === 'devices'
    );
    if (licensesClient?.homepageURL) {
      const base = licensesClient.homepageURL.replace(/\/$/, '');
      return `${base}/licenses/inventory`;
    }
    return '#';
  }, [oauthClientsData]);

  const correctionServicesUrl = useMemo(() => {
    const correctionServicesClient = oauthClientsData?.items.find(
      (client) => client.name === 'Correction Services'
    );
    return correctionServicesClient?.homepageURL || '#';
  }, [oauthClientsData]);

  return (
    <TeContainer column grow gap="xs" padding="xs" overflow="auto" alignItems="center">
      <Header text={t('title')} />
      <Section>
        <TeGrid gap="s">
          <Card
            icon="license"
            title={t('licenses.title')}
            description={t('licenses.description')}
            buttonText={t('licenses.buttonText')}
            route={{ to: licensesAppUrl }}
          />
          <Card
            icon="satellite_alt"
            title={t('correctionServices.title')}
            description={t('correctionServices.description')}
            buttonText={t('correctionServices.buttonText')}
            buttonIcon="open_in_new"
            route={{ to: correctionServicesUrl, target: '_blank', rel: 'noopener noreferrer' }}
          />
        </TeGrid>
      </Section>
    </TeContainer>
  );
}

export default Licenses;
